import { Suspense, useRef } from "react";
import { MODELS, useModel } from "../../../../../api";
import { Spinner } from "../../../../../design-system/utils/Spinner/Spinner.jsx";
import ErrorBoundary from "../../../../../lib/ErrorBoundary";
import VideoJS from "./VideoPlayer.jsx";

/**
 * Loads the PeerTube streaming URL and renders the player. Suspends while the URL
 * loads; throws if the video is unavailable (e.g. still transcoding), which the
 * wrapping ErrorBoundary turns into an inline notice.
 */
const PeertubeVideoPlayer = ({ data }) => {
  const modelData = useModel(MODELS.PEERTUBE_VIDEO_FILE_URL(data.id));
  const videoUrl = modelData?.videoUrl;
  const playerRef = useRef(null);

  const handlePlayerReady = (player) => {
    playerRef.current = player;
  };

  const videoJsOptions = {
    autoplay: false,
    controls: true,
    sources: [
      {
        src: videoUrl,
        type: "application/x-mpegURL",
      },
    ],
  };

  return <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />;
};

/**
 * PeertubeVideoEmbed embeds a PeerTube video. It is isolated in its own
 * Suspense + ErrorBoundary so a still-processing / unavailable video degrades to
 * an inline notice instead of bubbling up and blanking the surrounding content.
 *
 * @param {Object} props - Component properties.
 * @param {Object} props.data - Data object containing information about the video.
 * @param {string} props.data.id - Unique identifier for the PeerTube video.
 */
const PeertubeVideoEmbed = ({ data }) => (
  <ErrorBoundary
    key={data.id}
    fallback={
      <p>
        Dieses Video ist derzeit nicht verfügbar (evtl. noch in Bearbeitung).
      </p>
    }
  >
    <Suspense fallback={<Spinner />}>
      <PeertubeVideoPlayer data={data} />
    </Suspense>
  </ErrorBoundary>
);

export default PeertubeVideoEmbed;
